var toString = {}.toString

export default function isRegExp(value) {
  return toString.call(value) === '[object RegExp]'
}



// WEBPACK FOOTER //
// ./src/isRegExp.js